// Copyright (c) 2016 Deere & Company

import actions from '../../../../sharedmodules/actions-list';

export const updateReasonForChange = (reason) => ({
    reason,
    type: actions.UPDATE_REASON_FOR_CHANGE,
});
